import { useTranslation } from 'react-i18next';
import { Smartphone } from 'lucide-react';

import { BRAND } from '@/brand/brand';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * A small phone mark under a person's e-mail address in the team management: the person has the app
 * set up with push on at least one device. Nothing is shown for everybody else.
 */
export default function UserAppIndicator(properties: { active: boolean }) {
    const { t } = useTranslation();

    if (!properties.active) {
        return null;
    }

    const label = t('settingsPanel.userManagementPanel.usesApp', { appName: BRAND.appName });

    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        role="img"
                        tabIndex={0}
                        aria-label={label}
                        data-testid="user-uses-app"
                        className="mt-0.5 inline-flex rounded text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    >
                        <Smartphone aria-hidden className="h-4 w-4" />
                    </span>
                </TooltipTrigger>
                <TooltipContent>{label}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
